import React, { useRef, useState, useEffect } from "react";
import "./CitySelector.scss";

import api from "../../services/api";

export default function CitySelector(props) {
  const node = useRef();
  const listRef = useRef();
  const searchInput = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [cities, setCities] = useState({});
  const [filterTerm, setFilterTerm] = useState("");
  const [selectedCity] = useState(false);

  useEffect(() => {
    setIsOpen(props.isOpen);

    setTimeout(() => {
      searchInput.current.focus();
    }, 300);
  }, [props.isOpen]);

  useEffect(() => {
    async function getCityByTerm() {
      const response = await api.get(`/v1/cidades?cidade=${filterTerm}`);
      setCities(response.data.payload);
    }

    getCityByTerm();
  }, [filterTerm]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", escFunction);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", escFunction);
    };
  });

  const handleClick = (e) => {
    if (
      node.current.contains(e.target) ||
      e.target.classList.contains("estado")
    ) {
      return;
    }

    closeSelector();
  };

  const escFunction = (e) => {
    if (e.keyCode === 27) {
      closeSelector();
    }
  };

  function closeSelector() {
    listRef.current.scrollTop = 0;

    setIsOpen(false);

    props.onClose(false);
  }

  function selectCity(city) {
    if (window.parent.gtmAlteracaoCidade) {
      window.parent.gtmAlteracaoCidade(city);
    }

    props.onSelect(city);
    closeSelector();
  }

  return (
    <div
      className={"city-selector " + (isOpen ? "activeSelector" : "")}
      ref={node}
    >
      <span className="city-selector-close" onClick={closeSelector}></span>

      <div className="list" ref={listRef}>
        <div className="searchbar">
          <input
            type="text"
            value={filterTerm}
            onChange={(e) => setFilterTerm(e.target.value)}
            placeholder="Digite a cidade"
            ref={searchInput}
          />
        </div>
        <div className="list-options">
          {cities.length > 0 && (
            <div className="itens">
              {cities.map((city) => (
                <div
                  key={city.id}
                  onClick={() => selectCity(city)}
                  className={selectedCity.id === city.id ? "selected" : ""}
                >
                  <span>
                    {city.nome} / {city.estado}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
